import React, { useState } from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import * as Radio from "ds/Radio";

import * as S from "../InitializeWizard.styles";

const StartData = ["template", "existingCode"];

const Template = ({ onStartChange }) => {
  const intl = useIntl();

  const [method, setMethod] = useState(StartData[0]);

  const handleMethodChange = method => {
    setMethod(method);
    onStartChange(method);
  };

  return (
    <form>
      <Typography.Title tag="h3">
        {intl.formatMessage({
          id: "wizard.project.provisioning.start"
        })}
      </Typography.Title>
      <br />

      <Radio.Group defaultValue={method} onValueChange={handleMethodChange}>
        {StartData.map(type => (
          <>
            <Radio.Input
              key={`type-${type}`}
              id={type}
              label={
                type === "template"
                  ? intl.formatMessage({
                      id: "wizard.project.provisioning.blank"
                    })
                  : intl.formatMessage({
                      id: "wizard.project.provisioning.existing.code"
                    })
              }
              value={type}
            />

            {type === "template" ? (
              <>
                <S.Label>
                  {intl.formatMessage({
                    id: "wizard.project.provisioning.template"
                  })}
                </S.Label>
                <br />
              </>
            ) : (
              <S.Label>
                {intl.formatMessage<React.ReactNode>(
                  {
                    id: "wizard.project.provisioning.supports"
                  },
                  {
                    link: chucks => (
                      <Link
                        analyticId="wizard.project.provisioning.link.support.url"
                        variant="link"
                        href={intl.formatMessage({
                          id: "wizard.project.provisioning.link.support"
                        })}
                      >
                        {chucks}
                      </Link>
                    )
                  }
                )}
              </S.Label>
            )}
          </>
        ))}
      </Radio.Group>
    </form>
  );
};

export default Template;
